<template lang="pug">
b-modal#modal-report-cols(title='表示項目を変更',size="lg")
  .row.main
    .col-6.border-right
      ul
        li(v-for="col in cols_for_check")
          input(type="checkbox",:checked="col.active", @change="check($event, col)")
          label(v-if="col.display_name") {{ col.display_name }}
          label(v-else) {{ col.name }}
    .col-6
      h6 選択された列
      draggable.ul(v-model="default_cols")
        .li.btn.btn-block.btn-default.btn-flat(v-for="(col,idx) in default_cols",v-model="active_cols",:key="col.name",v-if="col.active")
          template(v-if="col.display_name")
            i.fas.fa-bars
            | {{ col.display_name }}
          template(v-else)
            i.fas.fa-bars
            | {{ col.name }}
  template(v-slot:modal-footer)
    b-form(inline)
      label.mr-sm-2 名前をつけて保存
      b-input.mr-sm-2(
        @input="setCustomColName($event)"
        @blur='$v.custom_col_name.$touch',
        :value="custom_col_name",
        :class="{ 'is-invalid': $v.custom_col_name.$invalid && $v.custom_col_name.$dirty, 'is-valid': !$v.custom_col_name.$invalid && $v.custom_col_name.$dirty }"
      )
      b-button(variant="primary",@click="submit") 保存
</template>

<script>
import Vue from 'vue'

import Draggable from 'vuedraggable';

import { required, url } from 'vuelidate/lib/validators'

export default {
  data(){
    return {
      cols_for_check: []
    }
  },
  methods: {
    setCustomColName(name){
      this.$store.commit("report/setCustomColName", name)
    },
    check(e, col){
      if(e.target.checked){
        //checkされた
        //col.active = true
        this.$store.commit("report/setActiveCol",{
          col: col,
          bool: true
        })
      } else {
        this.$store.commit("report/setActiveCol",{
          col: col,
          bool: false
        })
      }
    },
    async submit(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        //送信処理
        this.$v.$reset()
        const data = await this.$store.dispatch("report/saveCustomCol")
        this.$store.commit("report/addSavedCustomCols", data)
        this.$bvModal.hide('modal-report-cols')
        this.$toasted.success('登録しました')
        await sleep(10000)
        this.$toasted.clear()
      }
    }
  },
  components: {
    Draggable
  },
  async mounted(){
    await Vue.nextTick()
    //this.$bvModal.show('modal-report-cols')
    await this.$store.dispatch("report/getCvColNames")
    this.cols_for_check = Vue.util.extend({}, this.default_cols)
  },
  computed: {
    custom_col_name(){
      return this.$store.state.report.custom_col_name
    },
    default_cols:{
      get(){
        return this.$store.state.report.default_cols
      },
      set(val){
        this.$store.commit("report/setDefaultCol", val)
      }
    },
    active_cols(){
      return this.$store.getters["report/active_cols"]
    }
  },
  validations: {
    custom_col_name: {
      required
    }
  },
}
</script>
<style lang="scss" scoped>
.main{
  height:600px;
  overflow:scroll;
}
.border-right{
  border-right: 1px solid #eee;
}
ul{
  li{
    list-style:none;
    input{
      margin-right:5px;
    }
  }
}
.ul{
  h6{
    font-weight:900;
    margin-bottom:10px;
  }
  .li{
    &.btn{
    cursor:pointer;
    text-align:left;
    position:relative;
    i.fas{
      margin-right:10px;
    }
    i.fa-times{
      position:absolute;
      right:10px;
      top:10px;
    }
  }
  }
}
</style>
